import { render } from "./BotaoManuais.vue?vue&type=template&id=47bf691b"
import script from "./BotaoManuais.vue?vue&type=script&lang=js"
export * from "./BotaoManuais.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__